<template>
  <router-view></router-view>
</template>

<script>
export default {};
</script>

<style>
@font-face {
  font-family: "Cygre";
  src: url("./assets/fonts/Cygre-Regular.woff") format("woff");
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: "Cygre";
  src: url("./assets/fonts/Cygre-Medium.woff") format("woff");
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: "Cygre";
  src: url("./assets/fonts/Cygre-Bold.woff") format("woff");
  font-weight: 700;
  font-style: normal;
}
*:not(i) {
  font-family: "Cygre" !important;
}
.small-text {
  font-size: 10px;
}
.small-text-days {
  font-size: 12px;
}
.bold {
  font-weight: 600;
}
.pointer {
  cursor: pointer;
}
.card.no-border-card {
  border-radius: 25px !important;
}
button {
  border-radius: 30px !important;
}
h2.numberResult {
  font-size: 35px;
}
.card-body {
  padding: 2.3rem 3rem !important;
}
.btn-neutral:active,
.btn-neutral:focus {
  background: white !important;
}
.modal-altura-fixa {
  max-height: 90vh;
}

.modal-body-scrollable {
  max-height: 75vh;
  overflow-y: auto;
  padding-right: 10px; /* evitar scroll colado à borda */
}
.bg-gray {
  background: #f2eff2 !important;
}
.relative {
  position: relative !important;
}
.n-br {
  border-radius: 0px !important;
}
header {
  padding: 0px !important;
  border-radius: 25px !important;
}
header button {
  border-radius: 25px !important;
}
.drawer .card {
  border-radius: 25px;
}
.b-form-date-controls button.btn.btn-outline-danger.btn-sm {
  color: #ff825d;
  border-color: #ff825d;
}
.text-500 {
  font-weight: 500 !important;
}
</style>
